export default {
  id: 171,
  title: 'Target #171 - Pumpkin',
  url: 'https://cssbattle.dev/play/171',
  colors: ['#784972', '#F7FFCF'],
  solution:
    '<a a><a b><style>body{background:#784972}a{position:fixed;background:#f7ffcf}a[a]{width:100;height:150;border-radius:100%;top:100;left:150;box-shadow:0 0 0 10px #784972,-40px 0 #f7ffcf,-40px 0 0 10px #784972,-80px 0 #f7ffcf,-80px 0 0 10px #784972,40px 0 #f7ffcf,40px 0 0 10px #784972,80px 0 #f7ffcf,80px 0 0 10px #784972}a[b]{width:22;height:100;border-radius:9rem;top:50;left:189}</style>',
}
